import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getSupportContactDetails, SupportContactDetails } from "stores/classwizeConfigStore";

const SupportDetails = (): JSX.Element => {
	const { t } = useTranslation();
	const [contactDetails] = useState<SupportContactDetails>(getSupportContactDetails());
	const [isFetching] = useState(false);

	const hasDetails = () => {
		if (Object.keys(contactDetails).length !== 0) {
			for (const key of ["support_contact_phone", "support_contact_name", "support_contact_email"]) {
				const value = contactDetails[key as keyof typeof contactDetails];
				if (value) {
					return true;
				}
			}
		}
		return false;
	};

	if (isFetching) {
		return <div>{t("overview.supportLoading")}</div>;
	}

	if (!hasDetails()) {
		return <div>{t("overview.supportNotConfiguredShort")}</div>;
	}

	return (
		<div>
			{contactDetails.support_contact_name && (
				<div className="SupportDetails_row">
					<div className="SupportDetails_label">{t("overview.supportNameLabel")}</div>
					<div>{contactDetails.support_contact_name}</div>
				</div>
			)}
			{contactDetails.support_contact_email && (
				<div className="SupportDetails_row">
					<div className="SupportDetails_label">{t("overview.supportEmailLabel")}</div>
					<div>
						<a href={"mailto:" + contactDetails.support_contact_email}>{contactDetails.support_contact_email}</a>
					</div>
				</div>
			)}
			{contactDetails.support_contact_phone && (
				<div className="SupportDetails_row">
					<div className="SupportDetails_label">{t("overview.supportPhoneLabel")}</div>
					<div>{contactDetails.support_contact_phone}</div>
				</div>
			)}
		</div>
	);
};

export default SupportDetails;
